import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import { PATHS, SAGA_DELAY_TIMEOUT } from './../constants/Define';
import * as RedirectLinkService from './../services/redirectLinkService';
import i18n from '../constants/initLng';
import RedirectLink from '../models/RedirectLink';

import * as RedirectLinkActions from '../actions/redirectLinkAction';
import history from '../helpers/history';

function* getRedirectLink() {
    yield takeLatest(Types.REDIRECT_LINK_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(RedirectLinkService.getRedirectLink, params);
        yield put(RedirectLinkActions.setRedirectLinks(result));
    }, errorHandleRole(Types.REDIRECT_LINK_FAIL)))
}

function* getRedirectLinkDetail() {
    yield takeLatest(Types.REDIRECT_LINK_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(RedirectLinkService.getRedirectLinkDetail, action.id);
        yield put(RedirectLinkActions.setRedirectLinkDetail(result));
    }, errorHandleRole(Types.REDIRECT_LINK_FAIL)))
}

function* createRedirectLink() {
    yield takeLatest(Types.REDIRECT_LINK_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RedirectLinkService.createRedirectLinkDetail, action.redirectLink);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.redirectLink.fromLink);
        history.push(PATHS.REDIRECT_LINK.LIST.path);
        history.go();
    }, errorHandleRole(Types.REDIRECT_LINK_FAIL)))
}

function* updateRedirectLink() {
    yield takeLatest(Types.REDIRECT_LINK_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RedirectLinkService.updateRedirectLinkDetail, action.redirectLink);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.redirectLink.fromLink);
        yield put({ type: Types.REDIRECT_LINK_LIST_ACTION })
    }, errorHandleRole(Types.REDIRECT_LINK_FAIL)))
}

function* deleteRedirectLink() {
    yield takeLatest(Types.REDIRECT_LINK_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(RedirectLinkService.deleteRedirectLinkDetail, action.redirectLink);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.203'));
        yield delay(SAGA_DELAY_TIMEOUT)
        yield put({ type: Types.REDIRECT_LINK_LIST_ACTION, filters: action.filters.pageIndex })
    }, errorHandleRole(Types.REDIRECT_LINK_FAIL)))
}

function errorHandleRole(errorActionType) {
    return Func.sagaErrorHandler(function* (e){
        yield put({ type: errorActionType })
    }, 'redirectLink');
}

export function* redirectLinkSaga() {
    yield all([
        fork(getRedirectLink),
        fork(createRedirectLink),
        fork(deleteRedirectLink),
        fork(getRedirectLinkDetail),
        fork(updateRedirectLink),
    ])
}
